import React from 'react';

const UpArrowIcon = () => {

  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.54992 0.999878L6.54992 13M6.54992 0.999878L11.5499 6M6.54992 0.999878L1.5498 6" stroke="#222739" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};

export default UpArrowIcon;